import React, { useState } from "react";
import { Logo } from "../../assets";
import { LogoutButton, NotificationIcon, SupportIcon } from "../../assets/svg";
import { localStoreName } from "../../utils/constants";
import { StopTimer } from "../countdownTimer";
import { header, headerIconSet, avatar } from "./layout.module.css";
import { useHistory } from "react-router-dom";
// import jwt_decode from "jwt-decode"

const MainLayout = ({ children }) => {
  const userDetails = JSON.parse(localStorage.getItem(localStoreName));
  const [showLogout, setShowLogout] = useState(false)
  const history = useHistory()
  // const [unAuthorized, setUnauthorized] = useState(false)
  // const jwt = jwt_decode()
  // console.log('ee', jwt)
  // const { decode } = jwt_decode()
  // console.log('decode', decode)
  // const isAuthenticated = () => {
  // }
  
  const logout = () => {
    localStorage.clear(localStoreName)
    history.push("./login")
  }



  return (
    <>
      <header className={`${header} justify-content-between`}>
        <Logo />

        <StopTimer />

        <div className={`${headerIconSet} d-none d-md-flex`}>
          <SupportIcon />
          <NotificationIcon />

          <div className={avatar} style={{position: "relative"}} onClick={()=>setShowLogout(!showLogout)}>
            {showLogout ?
              <div style={{
                display:"flex", 
                alignItems: "center",
                justifyContent: "center",
                background: "#FEFEFE",
                border: "0.5px solid #B4BBCC",
                borderRadius: "16px",
                position: "absolute",
                top: "50px",
                right: "0px",
                width: "180px",
                height: "50px",
                margin: "20px 0",
                transition: "all 0.7s ease-in-out"
              }} onClick={()=> logout()}>
                <LogoutButton />
                <p style={{margin: "0px 20px"}}>Log-out</p>
              </div>
              : <></>
            }
            <span>
              {userDetails?.lastname?.substring(0, 1)}
              {userDetails?.firstname?.substring(0, 1)}
            </span>
          </div>
        </div>
      </header>

      <div className="LandingLayout-wrapper">{children}</div>
    </>
  );
};
export { MainLayout };
